import { render } from "./Pengumuman.vue?vue&type=template&id=ab957eb0&scoped=true"
import script from "./Pengumuman.vue?vue&type=script&lang=js"
export * from "./Pengumuman.vue?vue&type=script&lang=js"

import "./Pengumuman.vue?vue&type=style&index=0&id=ab957eb0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\HRIS BCK\\digajiin_fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab957eb0"]])

export default __exports__